/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICountryPickerViewProps } from './nos-country-picker';

/**
 * @param param0 - Root param.
 * @param param0.availableCountries - Cancel button.
 * @returns .
 */
const CountryPickerNode: React.FC<any> = ({ availableCountries }) => {
    return <Node className=''>{availableCountries}</Node>;
};

/**
 * Country Picker View Component.
 * @param props - Props.
 * @returns - Country Picker Module.
 */
const NosCountryPickerView: React.FC<ICountryPickerViewProps> = props => {
    const { CountryPicker, availableCountries } = props;

    return (
        <Module {...CountryPicker}>
            <CountryPickerNode availableCountries={availableCountries} />
        </Module>
    );
};

export default NosCountryPickerView;
